module.exports = "https://qp-assets.quero.com/assets/images/cobranca-finalizada.svg?938bda6f830a4be625141aeb8d9f21b4";